import React, { useState, useEffect } from 'react';
import Landing from './components/Landing';
import VistaCliente from './components/VistaCliente';
import PantallaPago from './components/PantallaPago';

const API = process.env.REACT_APP_API_URL;

const PALETA = {
  light: {
    bg: '#f0ece0', card: '#faf7f0', text: '#2a1f0f', muted: '#8b7355',
    border: '#d4c9a8', shadow: '0 1px 4px rgba(61,107,42,0.1)', subtext: '#4a3f2a',
    accent: '#3d6b2a', accentLight: '#eef5e8', badge: '#6b9a3a',
  },
  dark: {
    bg: '#0d150a', card: '#111a0d', text: '#d4e8c4', muted: '#6b8a5a',
    border: '#1a3010', shadow: '0 1px 4px rgba(0,0,0,0.5)', subtext: '#9ab88a',
    accent: '#6b9a3a', accentLight: '#0d2008', badge: '#4a7a28',
  }
};

function ResetPassword({ resetToken, onDone, dm }) {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm]   = useState('');
  const [error, setError]       = useState('');
  const [ok, setOk]             = useState(false);
  const [cargando, setCargando] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password.length < 8) return setError('Mínimo 8 caracteres');
    if (password !== confirm) return setError('Las contraseñas no coinciden');
    setCargando(true); setError('');
    try {
      const res = await fetch(process.env.REACT_APP_API_URL + '/api/auth/reset', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token: resetToken, password }),
      });
      const data = await res.json();
      if (!data.ok) return setError(data.error || 'Error al restablecer');
      setOk(true);
      setTimeout(onDone, 2500);
    } catch { setError('Error de conexión'); }
    finally { setCargando(false); }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: dm.bg, fontFamily: 'Inter, sans-serif', padding: 16 }}>
      <div style={{ background: dm.card, borderRadius: 20, padding: '32px 28px', width: '100%', maxWidth: 380, boxShadow: '0 10px 40px rgba(0,0,0,0.15)', border: '1px solid ' + dm.border, textAlign: 'center' }}>
        <img src="/favicon.png" alt="Montaraz" style={{ height: 52, marginBottom: 12 }} />
        <div style={{ fontWeight: 900, fontSize: 20, color: dm.text, marginBottom: 4 }}>Nueva contraseña</div>
        <div style={{ fontSize: 12, color: dm.muted, marginBottom: 24 }}>Montaraz · Guardián del Territorio</div>
        {ok ? (
          <div style={{ color: '#38a169', fontWeight: 700, padding: '10px 0' }}>
            ✓ Contraseña actualizada — redirigiendo...
          </div>
        ) : (
          <form onSubmit={handleSubmit} style={{ textAlign: 'left' }}>
            <div style={{ marginBottom: 10 }}>
              <input type="password" required placeholder="Nueva contraseña (mín. 8 caracteres)"
                minLength={8} value={password} onChange={e => setPassword(e.target.value)}
                style={{ width: '100%', padding: '10px 14px', border: '1.5px solid ' + dm.border, borderRadius: 10, fontSize: 14, background: dm.bg, color: dm.text, fontFamily: 'Inter, sans-serif', outline: 'none', boxSizing: 'border-box' }} />
            </div>
            <div style={{ marginBottom: 14 }}>
              <input type="password" required placeholder="Confirmar contraseña"
                value={confirm} onChange={e => setConfirm(e.target.value)}
                style={{ width: '100%', padding: '10px 14px', border: '1.5px solid ' + dm.border, borderRadius: 10, fontSize: 14, background: dm.bg, color: dm.text, fontFamily: 'Inter, sans-serif', outline: 'none', boxSizing: 'border-box' }} />
            </div>
            {error && (
              <div style={{ background: '#fff0f0', color: '#c53030', padding: '8px 12px', borderRadius: 8, fontSize: 13, marginBottom: 12, border: '1px solid #feb2b2' }}>{error}</div>
            )}
            <button type="submit" disabled={cargando} style={{ width: '100%', padding: '12px', background: dm.accent, color: 'white', border: 'none', borderRadius: 999, fontSize: 14, fontWeight: 700, cursor: cargando ? 'not-allowed' : 'pointer', opacity: cargando ? .7 : 1, fontFamily: 'Inter, sans-serif' }}>
              {cargando ? 'Guardando...' : 'Guardar nueva contraseña'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}

function StagingBanner() {
  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, zIndex: 9999,
      background: '#d69e2e', color: '#2a1f0f',
      padding: '6px 16px', textAlign: 'center',
      fontSize: 12, fontWeight: 700, fontFamily: 'Inter, sans-serif',
      letterSpacing: '.3px',
    }}>
      ⚠️ AMBIENTE DE PRUEBAS — Los datos y pagos aquí no son reales
    </div>
  );
}

export default function App() {
  const [usuario, setUsuario] = useState(null);
  const [token, setToken] = useState(null);
  const [resetToken] = useState(() => new URLSearchParams(window.location.search).get('reset_token'));
  const [pagoResultado] = useState(() => new URLSearchParams(window.location.search).get('pago'));
  const [tienePredios, setTienePredios] = useState(null);
  const [predios, setPredios] = useState([]);
  const [mostrarPago, setMostrarPago] = useState(false);
  const [predioParaPagar, setPredioParaPagar] = useState(null);
  const [darkMode, setDarkMode] = useState(() => localStorage.getItem('montaraz_dark') === 'true');

  const dm = darkMode ? PALETA.dark : PALETA.light;

  useEffect(() => {
    localStorage.setItem('montaraz_dark', darkMode);
    document.body.style.background = dm.bg;
  }, [darkMode]);

  useEffect(() => {
    const t = localStorage.getItem('satfire_token');
    const u = localStorage.getItem('satfire_usuario');
    if (t && u) { setToken(t); setUsuario(JSON.parse(u)); }
  }, []);

  useEffect(() => {
    if (usuario && token) { verificarPredios(); refrescarUsuario(); }
  }, [usuario, token]);

  // Refresca el plan real desde el servidor — el usuario guardado en localStorage queda
  // congelado en el momento del login, así que sin esto el badge trial/cliente puede mostrar
  // información vieja (ej. justo después de pagar, hasta el próximo login manual).
  const refrescarUsuario = async () => {
    try {
      const res = await fetch(API + '/api/auth/me', {
        headers: { Authorization: 'Bearer ' + token }
      });
      const data = await res.json();
      if (data.ok && data.usuario) {
        setUsuario(prev => {
          const actualizado = { ...prev, ...data.usuario };
          localStorage.setItem('satfire_usuario', JSON.stringify(actualizado));
          return actualizado;
        });
      }
    } catch (e) { /* silencioso — el usuario cacheado sigue sirviendo de fallback */ }
  };

  const verificarPredios = async (esReintento = false) => {
    try {
      const res = await fetch(API + '/api/cliente/predios', {
        headers: { Authorization: 'Bearer ' + token }
      });
      const data = await res.json();
      // Un fallo real (rate limit, error de servidor, etc.) no es lo mismo que "el usuario
      // no tiene predios" — antes cualquier error caía en el mismo `data.predios || []` y
      // mandaba al usuario a la pantalla de "agrega tu primer terreno" aunque sí tuviera uno,
      // perdiendo (visualmente) su sesión y sus datos. Ahora un fallo reintenta una vez y, si
      // persiste, deja el estado como estaba en vez de asumir que no hay predios.
      if (!res.ok || data.ok === false) {
        console.error('Error al verificar predios:', data.error || res.status);
        if (!esReintento) setTimeout(() => verificarPredios(true), 3000);
        return;
      }
      const lista = data.predios || [];
      setPredios(lista);
      setTienePredios(lista.length > 0);
    } catch (e) {
      if (!esReintento) setTimeout(() => verificarPredios(true), 3000);
    }
  };

  const handleLogin = (u, t) => { setUsuario(u); setToken(t); };

  const handleLogout = () => {
    localStorage.removeItem('satfire_token');
    localStorage.removeItem('satfire_usuario');
    setUsuario(null); setToken(null); setTienePredios(null);
    setMostrarPago(false); setPredioParaPagar(null);
  };

  const isStaging = process.env.REACT_APP_ENV === 'staging';

  if (resetToken) return (
    <ResetPassword resetToken={resetToken} dm={dm}
      onDone={() => { window.history.replaceState({}, '', '/'); window.location.reload(); }} />
  );

  // Redirigido de vuelta desde Flow después del pago
  if (pagoResultado && usuario) {
    window.history.replaceState({}, '', '/');
    if (pagoResultado === 'ok') verificarPredios();
  }

  if (!usuario) return (
    <>
      {isStaging && <StagingBanner />}
      <Landing onLogin={handleLogin} />
    </>
  );

  if (tienePredios === null) return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: dm.bg, color: dm.muted, fontFamily: 'Inter, sans-serif' }}>
      Cargando...
    </div>
  );

  if (!tienePredios) return (
    <Landing
      onLogin={handleLogin}
      authInicial={{ token, usuario }}
      autoOpenTerrain={true}
    />
  );

  if (mostrarPago && predioParaPagar) return (
    <>
      {isStaging && <StagingBanner />}
      <div style={isStaging ? { marginTop: 30 } : {}}>
        <PantallaPago
          usuario={usuario}
          token={token}
          predio={predioParaPagar}
          onVolver={() => { setMostrarPago(false); setPredioParaPagar(null); }}
          onExito={() => { setMostrarPago(false); setPredioParaPagar(null); verificarPredios(); }}
          dm={dm}
        />
      </div>
    </>
  );

  return (
    <>
      {isStaging && <StagingBanner />}
      <div style={isStaging ? { marginTop: 30 } : {}}>
        <VistaCliente
          usuario={usuario}
          token={token}
          onLogout={handleLogout}
          darkMode={darkMode}
          onToggleDark={() => setDarkMode(!darkMode)}
          dm={dm}
          onNuevoPredio={(predio) => { setPredioParaPagar(predio); setMostrarPago(true); }}
        />
      </div>
    </>
  );
}